import type { PayrollException, PayrollMonth, PayrollTabKey } from '../types/hrmsPayroll.types'

export const PAYROLL_MOCK_TODAY = '2026-09-28'

export const PAYROLL_BASE_PATH = '/admin/hrms/payroll'
export const SALARY_COMPONENTS_BASE_PATH = `${PAYROLL_BASE_PATH}/salary-components`
export const SALARY_COMPONENTS_EARNINGS_PATH = `${SALARY_COMPONENTS_BASE_PATH}/earnings`
export const SALARY_COMPONENTS_DEDUCTIONS_PATH = `${SALARY_COMPONENTS_BASE_PATH}/deductions`

export const SALARY_COMPONENTS_NEW_PATH = `${SALARY_COMPONENTS_BASE_PATH}/new/:type`
export const SALARY_COMPONENTS_NEW_EARNING_PATH = `${SALARY_COMPONENTS_BASE_PATH}/new/earning`
export const SALARY_COMPONENTS_NEW_DEDUCTION_PATH = `${SALARY_COMPONENTS_BASE_PATH}/new/deduction`
export const SALARY_COMPONENTS_EDIT_PATH = `${SALARY_COMPONENTS_BASE_PATH}/edit/:type/:componentId`

export const SALARY_COMPONENT_TYPE_SLUGS: Record<string, string> = {
  Earning: 'earning',
  Deduction: 'deduction',
}

export const SALARY_COMPONENT_NEW_PATHS: Record<string, string> = {
  earning: SALARY_COMPONENTS_NEW_EARNING_PATH,
  deduction: SALARY_COMPONENTS_NEW_DEDUCTION_PATH,
}

export const SALARY_COMPONENT_LIST_PATHS: Record<string, string> = {
  earning: SALARY_COMPONENTS_EARNINGS_PATH,
  deduction: SALARY_COMPONENTS_DEDUCTIONS_PATH,
}
export const SALARY_STRUCTURES_PATH = `${PAYROLL_BASE_PATH}/salary-structures`
export const PAYROLL_PROCESSING_PATH = `${PAYROLL_BASE_PATH}/payroll-processing`

export const SALARY_STRUCTURE_CREATE_PATH = `${SALARY_STRUCTURES_PATH}/create`
export const SALARY_STRUCTURE_COMPONENTS_PATH = SALARY_STRUCTURE_CREATE_PATH + '/components'
export const SALARY_STRUCTURE_MAPPING_PATH = SALARY_STRUCTURE_CREATE_PATH + '/mapping'
export const SALARY_STRUCTURE_REVIEW_PATH = SALARY_STRUCTURE_CREATE_PATH + '/review'
export const SALARY_STRUCTURE_VIEW_PARAM_PATH = `${SALARY_STRUCTURES_PATH}/view/:structureId`
export const SALARY_STRUCTURE_VIEW_PATH = (id: string) => `${SALARY_STRUCTURES_PATH}/view/${encodeURIComponent(id)}`

export const PAYROLL_TABS: {
  key: PayrollTabKey
  label: string
}[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'components', label: 'Salary Components' },
  { key: 'structures', label: 'Salary Structures' },
  { key: 'processing', label: 'Payroll Processing' },
]

export const PAYROLL_MONTH_OPTIONS: PayrollMonth[] = [
  { key: '2026-10', label: 'October 2026' },
  { key: '2026-09', label: 'September 2026' },
  { key: '2026-08', label: 'August 2026' },
  { key: '2026-07', label: 'July 2026' },
  { key: '2026-06', label: 'June 2026' },
  { key: '2026-05', label: 'May 2026' },
  { key: '2026-04', label: 'April 2026' },
]
